import { createContext } from 'react';

import { ModalType } from './types';
import type { ExternalPatientContextType } from './types';

export const ExternalPatientContext = createContext<ExternalPatientContextType>(
  {
    isIframe: false,
    externalPatientId: null,
    externalImageId: null,
    patientId: null,
    imageId: null,
  },
);

export const isValidModalType = (type: string): type is ModalType => {
  return Object.values(ModalType).includes(type as ModalType);
};

export const ONBOARDING_VIDEO_KEY = 'external-onboarding-video-watched';
